import moment, { Moment } from 'moment';
import i18n from 'i18n';

import styles from './DateMark.module.scss';

type Props = {
  date: Moment;
};

const DateMark = ({ date }: Props) => {
  return <div className={styles.mark}>{parseDate(date)}</div>;
};

export default DateMark;

const parseDate = (date: Moment) => {
  const ref = moment();

  if (date.isSame(ref, 'day')) {
    return i18n.t('play.home.feed.time.today');
  }

  ref.subtract(1, 'day');

  if (date.isSame(ref, 'day')) {
    return i18n.t('play.home.feed.time.yesterday');
  }

  for (let i = 0; i < 5; ++i) {
    ref.subtract(1, 'day');

    if (date.isSame(ref, 'day')) {
      return date.format('dddd');
    }
  }

  if (date.isSame(ref, 'year')) {
    return date.format('MMM D');
  }

  return date.format('YYYY-MM-DD');
};
